import axios from 'axios'
import { i18n } from '../../../plugins/i18n'
import { castAttributesForCamelCase, castAttributesForSnakeCase } from '../../../modules/string_converter'
export const companiesStorePaymentMethods = {
  namespaced: true,
  state: {
    data: null,
    preview: {},
    loading: false,
    previewLoading: false,
    loadError: false,
  },
  mutations: {
    resetData(state) {
      state.data = null
    },
    readStorePaymentMethods(state) {
      state.data = null
      state.loading = true
      state.loadError = false
    },
    readStorePaymentMethodsSuccess(state, payload) {
      state.data = castAttributesForCamelCase(payload.data)
      state.loading = false
      state.loadError = false
    },
    readStorePaymentMethodsFailure(state) {
      state.loading = false
      state.loadError = true
    },
    updateStorePaymentMethods(state) {
      state.loading = true
    },
    updateStorePaymentMethodsSuccess(state) {
      state.loading = false
    },
    updateStorePaymentMethodsFailure(state) {
      state.loading = false
    },
    readStorePaymentMethodsPreview(state) {
      state.previewLoading = true
    },
    readStorePaymentMethodsPreviewSuccess(state, payload) {
      state.preview = castAttributesForCamelCase(payload.data)
      state.previewLoading = false
    },
    readStorePaymentMethodsPreviewFailure(state) {
      state.previewLoading = false
    },
    createStorePaymentMethodsPreview(state) {
      state.previewLoading = true
    },
    createStorePaymentMethodsPreviewSuccess(state, payload) {
      state.preview = castAttributesForCamelCase(payload.data)
      state.previewLoading = false
    },
    createStorePaymentMethodsPreviewFailure(state) {
      state.previewLoading = false
    },
    reduceAttributes(state, { type, target, value }) {
      state.data[type][target] = value
    }
  },
  actions: {
    resetData({ commit }) {
      commit('resetData')
    },
    readStorePaymentMethods({ commit }, { company_uuid, store_uuid }) {
      commit('readStorePaymentMethods')
      return axios
        .get('/api/companies/' + company_uuid + '/stores/' + store_uuid + '/payment_methods.json')
        .then(res => {
          commit('readStorePaymentMethodsSuccess', res.data)
        })
        .catch(err => {
          commit('readStorePaymentMethodsFailure')
          commit('flash/updateFlash', { type: 'alert', message: err }, { root: true })
          console.error(err)
        })
    },
    updatePaymentMethods({ commit, state }, { company_uuid, store_uuid, params, synced }) {
      if (state.loading) return

      commit('flash/clearFlash', null, { root: true })
      commit('updateStorePaymentMethods')
      const payload = {
        store_gmb_location: {
          payment_method_synced: synced
        },
        ...castAttributesForSnakeCase(params)
      }
      return axios
        .put('/api/companies/' + company_uuid + '/stores/' + store_uuid + '/payment_methods.json', payload)
        .then(() => {
          commit('updateStorePaymentMethodsSuccess')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.updated', { value: i18n.t('models.storePaymentMethod.modelName') }) }, { root: true })
          return true
        })
        .catch(err => {
          console.error(err)
          commit('updateStorePaymentMethodsFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          return false
        })
    },
    async reducer({ commit }, { type, target, value }) {
      commit('reduceAttributes', { type, target, value })
    },
    readStorePaymentMethodsPreview({ commit }, { companyUuid, storeUuid }) {
      commit('readStorePaymentMethodsPreview')
      return axios
        .get('/api/companies/' + companyUuid + '/stores/' + storeUuid + '/payment_methods/previews')
        .then(res => {
          commit('readStorePaymentMethodsPreviewSuccess', res.data)
        })
        .catch(err => {
          console.error(err)
          commit('readStorePaymentMethodsPreviewFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    createStorePaymentMethodsPreview({ commit }, { companyUuid, storeUuid, params }) {
      commit('createStorePaymentMethodsPreview')
      const payload = {
        ...castAttributesForSnakeCase(params)
      }
      return axios
        .post('/api/companies/' + companyUuid + '/stores/' + storeUuid + '/payment_methods/previews', payload)
        .then(res => {
          commit('createStorePaymentMethodsPreviewSuccess', res.data)
        })
        .catch(err => {
          console.error(err)
          commit('createStorePaymentMethodsPreviewFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
  },
}
